// LICENSE : MIT
"use strict";
/*
4.3.8.一重引用符''
原則として和文では使用しません。
原文で一重引用符が使用されており、原文どおりに使用する必要がある場合のみ使用します。
 */
import {checkPair} from "./util/pair-checker";
export default function (context) {
    // do no anything
    return {};
}